var map = {
	"./amazon-web-services.png": 383,
	"./berkeley.png": 384,
	"./carnegie-mellon.png": 385,
	"./circle-logo.png": 386,
	"./facebook.png": 387,
	"./google.png": 388,
	"./landing-ai.png": 389,
	"./nus.png": 390,
	"./pinterest.png": 391,
	"./stanford.png": 392,
	"./tree-logo.png": 393,
	"./university-of-cambridge.png": 394,
	"./upstart.png": 395,
	"./walmart-labs.png": 396
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 358;